import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

// Static filter shapes — hoisted to module scope so they're the same
// reference on every render (Apollo v4's useQuery keys off variables
// identity, not deep equality).
const BULK_OTA_FILTERS = {
  combineAnd: [
    { field: "type", value: "DEVICE_FW_UPGRADE" }
  ],
  combineOr: [
    { field: "status", value: "N" },
    { field: "status", value: "P" },
    { field: "status", value: "S" },
    { field: "status", value: "Y" }
  ]
};

const ANY_OTA_FILTERS = {
  field: "ota_state",
  value: "in_progress"
};

export const useBulkOTACheck = () => {
  const {data, loading} = useQuery(JOBS, {
    variables: { filters: BULK_OTA_FILTERS }
  });
  
  if(!loading) {
    return data && data?.Jobs?.result?.length > 0;
  }
};

export const useAnyOTACheck = () => {
  const {data, loading} = useQuery(DEVICES, {
    variables: { filters: ANY_OTA_FILTERS }
  });

  if(!loading) {
    return data && data?.Devices?.result?.length > 0;
  }
};

const JOBS = gql`
query getJobs ($filters: GenericFilters) {
  Jobs(filters: $filters) {
    result {
      id
      status
      type
    }
  }
}
`;

const DEVICES = gql`
query getDevices($filters: GenericFilters!) {
  Devices (filters: $filters) {
    result {
      id
      is_active
      ota_state
      ota_progress
      modified_at
    }
  }
}
`;
